module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isCollapsed) ? _c('scale-editor-collapsed', {
    attrs: {
      "question": _vm.value,
      "isEditable": _vm.isEditable,
      "isReverseOrder": _vm.value.isChoiceOrderReversed
    },
    on: {
      "onToggleCollapse": _vm.handleToggleCollapse
    },
    model: {
      value: (_vm.computedChoices),
      callback: function($$v) {
        _vm.computedChoices = $$v
      },
      expression: "computedChoices"
    }
  }) : _c('scale-editor-expanded', {
    attrs: {
      "question": _vm.value,
      "isEditable": _vm.isEditable,
      "isReverseOrder": _vm.value.isChoiceOrderReversed
    },
    on: {
      "onToggleCollapse": _vm.handleToggleCollapse,
      "onReverseOrder": _vm.handleReverseOrder
    },
    model: {
      value: (_vm.computedChoices),
      callback: function($$v) {
        _vm.computedChoices = $$v
      },
      expression: "computedChoices"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-409cd989","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/editors/scale/ScaleEditor.vue
// module id = 3247
// module chunks = 3